const MealTypes = () => import("./views/MealTypes.vue");
const MealTypeEdit = () => import("./views/MealTypeEdit.vue");

const route = "/mealTypes";

export default [
  {
    path: route,

    name: "mealTypes.list",
    component: MealTypes,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "mealTypes.create",
    component: MealTypeEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:mealTypeId/edit`,
    name: "mealTypes.edit",
    component: MealTypeEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
